import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import TRANSLATIONS_EN from './en/common.json';
import QUIZ_EN from './en/quiz.json';
import TEST_EN from './en/test.json';
import CHAT_EN from './en/chat.json';
import PERMISSIONS_EN from './en/permissions.json';
import GRADES_EN from './en/grades.json';
import ATTENDANCE_EN from './en/attendance.json';
import LIVECLASSES_EN from './en/live_classes.json';
import STUDY_EN from './en/study.json';
import LOGIN_EN from './en/login.json';
import MAIN_MENU_SEARCH_EN from './en/main-menu-search.json';
import ERROR_EN from './en/error.json';
import TRANSLATIONS_DE from './de/common.json';
import TEST_DE from './de/test.json';
import CHAT_DE from './de/chat.json';
import PERMISSIONS_DE from './de/permissions.json';
import GRADES_DE from './de/grades.json';
import ATTENDANCE_DE from './de/attendance.json';
import LIVECLASSES_DE from './de/live_classes.json';
import STUDY_DE from './de/study.json';
import LOGIN_DE from './de/login.json';
import MAIN_MENU_SEARCH_DE from './de/main-menu-search.json';
import ERROR_DE from './de/error.json';
import TRANSLATIONS_EE from './ee/common.json';
import TEST_EE from './ee/test.json';
import CHAT_EE from './ee/chat.json';
import PERMISSIONS_EE from './ee/permissions.json';
import GRADES_EE from './ee/grades.json';
import ATTENDANCE_EE from './ee/attendance.json';
import LIVECLASSES_EE from './ee/live_classes.json';
import STUDY_EE from './ee/study.json';
import LOGIN_EE from './ee/login.json';
import MAIN_MENU_SEARCH_EE from './ee/main-menu-search.json';
import ERROR_EE from './ee/error.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: TRANSLATIONS_EN,
      quiz: QUIZ_EN,
      test: TEST_EN,
      chat: CHAT_EN,
      permissions: PERMISSIONS_EN,
      grades: GRADES_EN,
      attendance: ATTENDANCE_EN,
      live_classes: LIVECLASSES_EN,
      study: STUDY_EN,
      login: LOGIN_EN,
      search: MAIN_MENU_SEARCH_EN,
      error: ERROR_EN,
    },
    de: {
      common: TRANSLATIONS_DE,
      test: TEST_DE,
      chat: CHAT_DE,
      permissions: PERMISSIONS_DE,
      grades: GRADES_DE,
      attendance: ATTENDANCE_DE,
      live_classes: LIVECLASSES_DE,
      study: STUDY_DE,
      login: LOGIN_DE,
      search: MAIN_MENU_SEARCH_DE,
      error: ERROR_DE,
    },
    ee: {
      common: TRANSLATIONS_EE,
      test: TEST_EE,
      chat: CHAT_EE,
      permissions: PERMISSIONS_EE,
      grades: GRADES_EE,
      attendance: ATTENDANCE_EE,
      live_classes: LIVECLASSES_EE,
      study: STUDY_EE,
      login: LOGIN_EE,
      search: MAIN_MENU_SEARCH_EE,
      error: ERROR_EE,
    },
  },
});

i18n.changeLanguage(process.env.REACT_APP_DEFAULT_LNG);
export default i18n;
